import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { searchCorporationsInNationalTaxAgency } from '@src/api'
import {
  DefaultApiSearchCorporationsInNationalTaxAgencyRequest,
  SearchCorporationsInNationalTaxAgency200ResponseInner,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useSearchCorporationsInNationalTaxAgency = (
  params: DefaultApiSearchCorporationsInNationalTaxAgencyRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery<
    AxiosResponse<Array<SearchCorporationsInNationalTaxAgency200ResponseInner>>,
    AxiosResponse<Error>
  >({
    enabled: !!params.name,
    queryFn: () => searchCorporationsInNationalTaxAgency(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.SEARCH_CORPORATIONS_IN_NATIONAL_TAX_AGENCY,
      params,
    ],
  })
}
